export const locale = {
  lang: 'zh2',
  data: {
    'NAV': {
      'APPLICATIONS': '应用领域',
      'CONFIG': '设定值',
      'TOOLS': {
        'TITULO': '工具类',
        'CHAT': '聊天室',
        'TODO': '待办事项清单',
        'BROKER': '经纪人配置',
        'CHANGELOG': '变更日志',
        'KNOWLEDGE': '知识库',
        'WEB_COM_PROF':'网络公司简介',
      },
      'RESULTS': {
        'TITULO': '结果',
        'ENLACES': {
          'TI': '报告中',
          'TI_ESPANA': '在线报告',
          'COVID': 'COVID调查结果'
        },
        'ENLACES5': {
          'TI': '报告中 5.0',
          'COVID': 'Covid调查结果'
        },
        'ENLACES_ACTION_GO':{
          'TITULO':'ActionGo',
          // 'TITULO':'行动计划-领导人',
        },
        'ENLACES_GO_FLOW':{
          'TITULO':'去流结果',
        }
      },
      'ACADEMY'        : {
        'TITULO': '测试学院',
        'BADGE': '69'
      },
      'CERTIFICAR'        : {
        'TITULO': '证明',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': '证明',
          '1': '认证2.0',
          '3': '认证3.0',
          '4': '认证银',
          'SPA': '配置调查'
        }
      },
      'CERTIFICARN35'        : {
        'TITULO': '认证NOM35',
        'BADGE': '69'
      },
      'MEDIR'        : {
        'TITULO': '测量',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': '测量',
          '1': '测量增强',
          '2': '测量+ MST',
          '3': '按面积测量',
          '4': '领导者衡量',
          '5': '尺寸测量',
          '6': '测量证明',
          '7': '测量 3.0',
        }
      },
      'PULSE'        : {
        'TITULO': '脉冲检查',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': '脉冲检查',
          '1': '脉冲检查 3.0',
        }
      },
      'FOCUS'        : {
        'TITULO': '重点地区',
        'BADGE': '69'
      },
      'ENCUESTAS':{
                 'TITULO': '附加认证',
                 'BADGE': '69',
                 'SUBPRODUCTOS':{
                   '0': 'AMCO',
                   '1': '体面的工作',
                   '2': '第一份工作',
                 }
      },
      'NORMA35': {
          'TITULO': 'Norm 035'
      },
      'NOM35BETHE': {
          'TITULO': 'Norm 035 better'
      },
      'NOM35PLA': {
          'TITULO': 'Norm 035 silver'
      },
      'NOM35V3': {
          'TITULO': 'Norm 035 3.0'
      },
      'LANGUAJE'        : {
        'TITULO': '测试兰瓜耶',
        'BADGE': '69'
      },
      'LOGIN'        : {
        'TITULO': '测试登录',
        'BADGE': '69'
      },
      'PROFILECREATOR'        : {
        'TITULO': '个人资料创建者',
        'BADGE': '69'
      },
      'PROFILELIST'        : {
        'TITULO': '公司资料',
        'BADGE': '69'
      },
      'NOPRODUCTOS'        : {
        'TITULO': '您没有产品',
        'BADGE': '69'
      },
      'RESPTI': {
        'TITULO': 'IT经理'
      },
      'REQTEC': {
        'TITULO': '技术要求'
      },
      'CLOUD': {
        'TITULO': '文件管理器',
        'TITULO_ESPANA': '报告下载',
      },
      //Culture Audit
      'CULTURE': {
        'TITULO': '文化评估'
      },
      //Culture Audit2
      'CULTURE2': {
        'TITULO': '文化评估5.0'
      },
      //Culture Audit training
      'CATR': {
        'TITULO': '文化审核培训'
      },
      //Feedback
      'FEEDBACK': {
        'TITULO': '反馈'
      },
      //Acercade
      'ABOUT': {
        'TITULO': '变更日志'
      },
      'QUESTIONS': {
        'TITULO': '常问问题'
      },
      'VIDEOS': {
        'TITULO': '教学视频'
      },
      'CONSULTAR_E': {
        'TITULO': '咨询调查'
      },
      'CALEND_SUR': {
        'TITULO':'调查日历'
      },
      'VIDEOSADMIN': {
        'TITULO': '管理员影片'
      },
      'AUDITORIA-AUTO': {
          'TITULO':'自动审核'
        },
        'CULTURETURQUIA1': {
          'TITULO': '文化简介文化审核5.0'
        },'CULTURETURQUIA2': {
          'TITULO': '文化简介5.0'
        },'CULTURETURQUIA3': {
          'TITULO': '文化审核5.0'
        },
        'CULTUREMX1': {
          'TITULO': '文化审核5.0'
        },'CULTUREMX2': {
          'TITULO': '文化审核哥斯达黎加'
        },'CULTUREMX3': {
          'TITULO': '文化审核GoFlow'
        },'CULTUREMX4': {
          'TITULO': '文化审核5.0巴拿马'
        },'CULTUREMX5': {
          'TITULO': '文化审核5.0战略合作伙伴'
        },
        'CULTUREMX11': {
          'TITULO': 'SP 2022'
        },
        'CULTUREMX12': {
          'TITULO': '文化审计 GoFlow 2-2022'
        },
        'CULTUREMX13': {
          'TITULO': '文化审核标准 1'
        },
        'CULTUREMX14': {
          'TITULO': '文化审计® CA&C'
        },
        'CULTUREMX15': {
          'TITULO': '文化审核（认证）2022'
        },
        'CULTUREMX16': {
          'TITULO': '文化审计（认证, rkg.） 2022'
        },
        'CULTUREMX17': {
          'TITULO': '文化审计（认证, rkg. y adic.） 2022'
        },
        'CULTUREMX18': {
          'TITULO': '文化审计（认证, rkg. y adic.） 2024'
        },
        'CULTUREMX19': {
          'TITULO': '文化简报（认证）2024'
        },
        'CULTUREMX20': {
          'TITULO': '文化审计（认证和排名）2024'
        },
        'CULTURECH1': {
          'TITULO': '文化审核'
        },'CULTURECH2': {
          'TITULO': '文化评估 5.0'
        },'CULTURECH3': {
          'TITULO': '文化审核 SP'
        },'CULTURECH4': {
          'TITULO': '文化审计 5.0'
        },'CULTURECH5': {
          'TITULO': '4ALL 文化评估'
        },
        'CULTUREESP1':{
          'TITULO': 'Culture Audit'
        },
        'CULTUREESP2':{
          'TITULO': 'Culture Audit 5.0'
        },
        'CULTUREESP3':{
          'TITULO': 'Action Plan'
        },
        'CULTUREBRI':{
          'TITULO': '文化简介',
          'Culture Brief': '文化简介',
        },
        'CULTUREAUDI':{
          'TITULO': '文化审计',
          'Culture Audit': '文化审计',
        },
        'CONTACTO':{
          'TITULO': '联系'
        },
        'ACTIONGOADMIN':{
          'TITULO': '行动GO® 管理员',
        },
        'ACTIONGO':{
          'TITULO': '行动GO®',
        },
        'LEADERGOADMIN':{
          'TITULO': '领导者GO® 管理员',
        },
        'LEADERGOUSER':{
          'TITULO': '领导者GO®',
        },
        'medir_INNO':{
          'TITULO': '动感调查',
        },
        'CULTURE_OZEL':{
          'TITULO': '特别清单',
        },
        'Culture_Ozel_TR1':{
          'TITULO': '社会责任和志愿服务',
        },
        'CONTROL_SURVE':{
          'TITULO': '测量控制',
        },
        'CONSUL_REQUE':{
          'TITULO': '咨询要求',
        },
        'SURVEY_GENERIC':{
        'TITULO': '通用调查报告',
      },

    }
  }
};
